const agencies = [
  {
    rank: 2,
    name: 'Custom Health Plans',
    focus: 'Highly rated for their personalized service in finding private individual and family plans. They are known for simplifying the process and explaining complex policy details clearly.',
    location: 'Serves the Greater Houston area',
    image: 'health insurance policy documents medical forms stethoscope clipboard on professional desk organized healthcare paperwork clean bright lighting insurance coverage planning concept simple background',
  },
  {
    rank: 3,
    name: 'Selected Benefits, Inc.',
    focus: 'A concierge-style agency specializing in both individual policies and group health insurance for small businesses, offering access to major carriers.',
    location: 'Houston and surrounding areas',
    image: 'health insurance card medical ID card prescription medication bottles healthcare coverage concept organized medical supplies on clean white surface professional healthcare management bright lighting',
  },
  {
    rank: 4,
    name: 'HealthMarkets (Local Agents)',
    focus: 'Local agents consistently receive top-tier reviews for responsiveness and ability to find affordable coverage options for individuals and self-employed clients.',
    location: 'Agents located throughout Houston',
    image: 'medical stethoscope with health insurance forms documents and pen on desk healthcare coverage planning concept professional medical equipment clean organized workspace natural bright lighting',
  },
  {
    rank: 5,
    name: 'Texas Family Benefits',
    focus: 'Helps clients with a wide range of needs, including individual health, dental, vision, and life insurance, as well as employee benefit packages.',
    location: 'Houston',
    image: 'health insurance application forms with calculator pen and medical symbols healthcare cost planning concept organized paperwork clean desk bright natural lighting insurance coverage documents',
  },
  {
    rank: 6,
    name: 'Dean & Draper Insurance Agency',
    focus: 'Offers a comprehensive suite of insurance products, including robust health insurance departments for both commercial groups and individuals.',
    location: 'Multiple offices in the Houston area',
    image: 'medical clipboard with health insurance checklist stethoscope and healthcare documents on professional desk organized medical paperwork bright clean lighting insurance planning concept simple background',
  },
  {
    rank: 7,
    name: 'IHS Insurance Group',
    focus: 'Well-regarded for helping seniors and individuals navigate health coverage options by shopping multiple top-rated carriers.',
    location: 'Houston',
    image: 'health insurance policy booklet with medical cross symbol prescription bottles and healthcare documents on clean surface organized medical supplies bright natural lighting coverage planning concept',
  },
  {
    rank: 8,
    name: 'Allwin Insurance Agency',
    focus: 'Known for being hands-on and helping clients understand private plan networks (HMO vs. PPO), with a focus on affordability.',
    location: 'Houston',
    image: 'health insurance comparison charts documents with stethoscope and medical forms on desk healthcare coverage options planning concept organized paperwork clean bright lighting professional setting',
  },
  {
    rank: 9,
    name: 'Bowen, Miclette & Britt Insurance Agency',
    focus: 'Excellent for business owners looking for group health benefits, though they also handle individual risk management.',
    location: 'Houston',
    image: 'medical insurance card with stethoscope prescription pad and healthcare documents on professional desk organized medical supplies clean bright lighting health coverage concept simple background',
  },
  {
    rank: 10,
    name: 'Houston Independent Insurance (Mike Bauer)',
    focus: 'A boutique operation offering objective advice and a lack of pressure, focusing purely on finding the right plan fit.',
    location: 'Pearland/Houston area',
    image: 'health insurance forms with pen calculator and medical symbols on clean desk healthcare planning concept organized paperwork bright natural lighting insurance coverage documents professional workspace',
  },
];

export default function AgencyList() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Top 10 Health Insurance Agencies
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Houston's most trusted health insurance experts, ranked by expertise, service quality, and client satisfaction
          </p>
        </div>

        <div className="space-y-8">
          {agencies.map((agency, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-200"
            >
              <div className="grid md:grid-cols-3 gap-0">
                <div className="relative h-64 md:h-auto">
                  <img
                    src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7Bagency.image%7D&width=600&height=400&seq=agency-${agency.rank}&orientation=landscape`}
                    alt={agency.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 bg-teal-500 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl shadow-lg">
                    #{agency.rank}
                  </div>
                </div>

                <div className="md:col-span-2 p-6 md:p-8">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">{agency.name}</h3>
                      <div className="flex items-center space-x-2 text-gray-600 text-sm">
                        <i className="ri-map-pin-line text-teal-500"></i>
                        <span>{agency.location}</span>
                      </div>
                    </div>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-teal-600 mb-2 uppercase tracking-wide">Specialization</h4>
                    <p className="text-gray-700 leading-relaxed">{agency.focus}</p>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-700">
                      <i className="ri-user-heart-line mr-1"></i>
                      Self-Employed Friendly
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700">
                      <i className="ri-shield-check-line mr-1"></i>
                      Private Insurance
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                      <i className="ri-money-dollar-circle-line mr-1"></i>
                      Cost Savings
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
